import { DOCUMENT } from '@angular/common'
import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'

import { DomainService } from './domain.service'

@Injectable({
	providedIn: 'root',
})
export class ThemeService {
	constructor(
		@Inject(DOCUMENT) private readonly document: Document,
		readonly domainService: DomainService,
		readonly http: HttpClient,
	) {}

	initTheme() {
		this.loadTheme()
		this.updateFavicon(`${this.domainService.wlAssetURL}/favicon.png`)
		this.updateTitle(this.domainService.title)
	}

	loadTheme(): void {
		const domain = this.domainService.domain
		const themeClass = domain.replace('.', '_')
		document.body.classList.forEach((cls) => {
			if (cls.endsWith('_com') || cls.endsWith('_net')) {
				document.body.classList.remove(cls)
			}
		})
		document.body.classList.add(themeClass)
	}

	updateFavicon(faviconPath: string): void {
		const link: HTMLLinkElement = this.document.querySelector("link[rel*='icon']") || this.document.createElement('link')
		link.type = 'image/x-icon'
		link.rel = 'shortcut icon'
		link.href = faviconPath
		this.document.getElementsByTagName('head')[0].appendChild(link)
	}

	updateTitle(title: string): void {
		this.document.title = title
	}
}
